// Generated by ReScript, PLEASE EDIT WITH CARE

import * as DragPreview13BindJs from "./DragPreview13.bind.js";

var make = DragPreview13BindJs.Preview;

export {
  make ,
  
}
/* make Not a pure module */
